import { Theme } from '../../ITheme';
import crashTheme from '../../crash.theme';

const skySnifferTheme: Theme = {
  ...crashTheme,
  colors: {
    ...crashTheme.colors,
    background: '#0D1117',
    background2: '#5e6062ff',
    background3: '#1b1c1d',
    background4: '#bbc0c5ff',
    qbet: '#484b4cff',
    slider: '#353536ff',
    primary: '#FF4757',
    secondary: '#232628ff',
    text: '#FFFFFF',
    overlay: 'rgba(0, 0, 0, 0.5)',
    border: '#FFFFFF33',
    betborder: '#2ED573',
    betbutton: '#2ED573',
    betIdle: '#2ED573',
    betButtonHover: '#099442',
    betCashout: '#FFE23B',
    betCashHover: '#BD9E00',
    betCancel: '#E61F0C',
    betCancelHover: '#B41800',
    betCancelPress: '0 0 0 0.2rem rgba(230, 31, 12, 0.5)',
    betCancelPressMobile: '#c41a0a',
    autoplayBtBg: '#1D7ACA',
    autoplayBtBgborder: '#53b1cdff',
    autoplayBgHover: '#007bff',
    cancelborder: '#E61F0C',
    betCancelShadow: '0px 0px 6px #E61F0C, inset 0px 0px 0px 3px #E61F0C',
    cashoutborder: '#FFE23B',
    text2: '#ede7e7e0',
    multiplierHigh: '#9333ea',
    multiplierMedium: '#F59E0B',
    multiplierLow: '#22C55E',
    multiplierBase: '#1cadda',
    msgBg: 'rgba(29, 45, 38, 0.9)',
  },
  fonts: {
    ...crashTheme.fonts,
    primary: 'Orbitron, sans-serif',
    button: 'Orbitron, sans-serif',
  },
  uiElements: {
    ...crashTheme.uiElements,
    button: {
      ...crashTheme.uiElements.button,
      borderRadius: '8px',
      padding: '10px 18px',
      fontSize: '15px',
    },
    card: {
      ...crashTheme.uiElements.card,
      borderRadius: '12px',
      shadow: '0 4px 10px rgba(0,229,255,0.2)',
    },
    modal: {
      ...crashTheme.uiElements.modal,
      borderRadius: '16px',
      background: '#111827',
    },
  },
};

export default skySnifferTheme;
